import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-container-met-zak',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconContainerMetZak {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M26.03 5H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h1v-.04C4 .88 4.88 0 5.96 0h15.06a2 2 0 0 1 2 2h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1Zm-9.92 29c.08-.42.22-.83.45-1.21 1.08-1.77 1.2-2.45 1.21-2.57.05-.43.09-.64.12-.83.03-.15.04-.22.06-.48.02-.24.04-.51.06-.78.16-2.29.33-4.14.85-5.33.46-1.04 1.77-2.12 3.14-3.01l-.53-1.27c-.38-.68-.4-1.49-.05-2.2.27-.55.75-.95 1.32-1.2l.28-8.1H4v20s.05-.02.07-.03c.83-.6 1.84-.97 2.94-.97 2.76 0 5.01 2.24 5.01 5 0 1.13-.39 2.16-1.02 3h5.12Zm-9.1-6c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m11.1 7.18c.21.51.65.82 1.16.82h13.48c.51 0 .95-.31 1.16-.82.18-.44.08-.94-.16-1.35-.9-1.48-1.41-2.62-1.49-3.39-.08-.76-.14-.69-.19-1.38-.13-1.7-.25-4.34-.74-5.47-.48-1.08-4.19-3-4.19-3l1.87-3.85c.31-.47-.49-.93-1.16-.66l-.94.37c-.63.25-1.35.38-2.08.38h-.82c-.6 0-.99.41-.72.77l1.25 3s-3.32 1.89-3.81 3c-.5 1.13-.61 3.77-.74 5.47-.05.69-.11.62-.19 1.38-.09.77-.59 1.9-1.49 3.39-.25.4-.34.91-.16 1.35Z"/>
</svg>

    );
  }
}
